"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BulkEditProductAttributesDialog = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const debounce_1 = __importDefault(require("debounce"));
const bulk_edit_attributes_dialog_constants_1 = require("./bulk-edit-attributes-dialog.constants");
const bulk_edit_product_attributes_dialog_styles_1 = require("./bulk-edit-product-attributes-dialog.styles");
const hooks_1 = require("../hooks");
const product_attribute_control_container_1 = require("./partials/product-attribute-control.container");
const product_value_control_container_1 = require("./partials/product-value-control.container");
const hooks_2 = require("../../../client/hooks");
const hooks_3 = require("../../../client/product/hooks");
const proposal_1 = require("../../../client/proposal");
const components_1 = require("../../../components");
const generic_1 = require("../../../generic");
const hooks_4 = require("../../../../hooks");
const localization_1 = require("../../../../localization");
const store_1 = require("../../../../store");
const AFFECTED_COUNT_TRIGGER_DEBOUNCE_DELAY = 700;
const BulkEditProductAttributesDialog = ({ productsFilter, selectedProductsCount, expectedMatchedProductCount, initialAttributeId, selectedTreeNodeId, onSubmit, onClose, onProductListRefreshStateChange, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addSuccess } = (0, hooks_4.useNotification)();
    const selectedCatalogId = (0, store_1.useSelectedCatalogId)();
    const { refetchProductList } = (0, hooks_2.useRefetchQueries)();
    const { refetchCounters } = (0, hooks_2.useRefetchCounters)();
    const [selectedAttributeId, setSelectedAttributeId] = (0, react_1.useState)(initialAttributeId);
    const [operationType, setOperationType] = (0, react_1.useState)(bulk_edit_attributes_dialog_constants_1.BulkEditOperationTypes.Replace);
    const [selectedValues, setSelectedValues] = (0, react_1.useState)([]);
    const [isAffectedCountDebouncing, setIsAffectedCountDebouncing] = (0, react_1.useState)(false);
    const handleSuccess = () => addSuccess(t({ key: 'BULK_EDIT_SUCCESS_MESSAGE' }));
    const refetchProductsAfterBulkEdit = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        onProductListRefreshStateChange === null || onProductListRefreshStateChange === void 0 ? void 0 : onProductListRefreshStateChange(true);
        try {
            yield refetchProductList(selectedTreeNodeId);
        }
        finally {
            onProductListRefreshStateChange === null || onProductListRefreshStateChange === void 0 ? void 0 : onProductListRefreshStateChange(false);
        }
    }), [onProductListRefreshStateChange, refetchProductList, selectedTreeNodeId]);
    const { addBulkAssertions, isLoading, error, } = (0, hooks_3.useBulkAssertions)({
        catalogId: selectedCatalogId,
        onCompleted: () => {
            void refetchProductsAfterBulkEdit();
            void refetchCounters({ selectedTreeNodeId, attributeName: selectedAttributeId });
            handleSuccess();
            onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(selectedAttributeId);
        },
    });
    const isWipeAllValuesMode = operationType === bulk_edit_attributes_dialog_constants_1.BulkEditOperationTypes.Delete && !selectedValues.length;
    const { triggerAffectedCountQuery, shouldUseOutOfStrategyFilter, shouldRunAffectedCountQuery, isAffectedCountBusy, shouldShowAffectedProductsBanner, affectedProductsCount, skippedProductsCount, nodeStrategyAttributes, } = (0, hooks_1.useBulkEditAffectedProductsCount)({
        selectedTreeNodeId,
        selectedAttributeId,
        selectedValues,
        operationType,
        productsFilter,
        selectedProductsCount,
    });
    const debouncedTriggerAffectedCountQuery = (0, react_1.useMemo)(() => (0, debounce_1.default)(() => {
        setIsAffectedCountDebouncing(false);
        void triggerAffectedCountQuery();
    }, AFFECTED_COUNT_TRIGGER_DEBOUNCE_DELAY), [triggerAffectedCountQuery]);
    (0, react_1.useEffect)(() => {
        debouncedTriggerAffectedCountQuery.clear();
        if (!shouldRunAffectedCountQuery) {
            setIsAffectedCountDebouncing(false);
            return;
        }
        setIsAffectedCountDebouncing(true);
        void debouncedTriggerAffectedCountQuery();
        return debouncedTriggerAffectedCountQuery.clear;
    }, [debouncedTriggerAffectedCountQuery, shouldRunAffectedCountQuery]);
    const isAffectedCountUiBusy = isAffectedCountBusy || isAffectedCountDebouncing;
    const handleSubmit = () => {
        const args = [selectedAttributeId, selectedValues];
        const labels = (0, proposal_1.getProductAssertionBatchLabelsInput)(isWipeAllValuesMode ? proposal_1.BulkAssertionOperationTypes.DeleteAll : bulk_edit_attributes_dialog_constants_1.bulkEditOperationTypesToBulkAssertionTypes[operationType], ...args);
        void addBulkAssertions([
            Object.assign({ labels, productTreeNodeId: selectedTreeNodeId, filter: productsFilter.product, presentationAttributes: productsFilter.presentationAttributes, presentationAttributeFilterStrategy: productsFilter.presentationAttributeFilterStrategy, isReviewed: productsFilter.isReviewed }, (shouldUseOutOfStrategyFilter && {
                nodeStrategyAttributes,
            })),
        ], expectedMatchedProductCount);
    };
    const toggleButtonOptions = (0, react_1.useMemo)(() => bulk_edit_attributes_dialog_constants_1.bulkEditOperationTypes.map((type) => ({ title: t({ key: bulk_edit_attributes_dialog_constants_1.bulkEditOperationTypesToMessageKey[type] }), value: type })), [t]);
    const isSubmitDisabled = !selectedAttributeId || (!isWipeAllValuesMode && !selectedValues.length) || isAffectedCountUiBusy;
    return (react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledActionDialog, { open: true, maxWidth: false, proceedButtonProps: {
            title: t({ key: 'APPLY' }),
            disabled: isSubmitDisabled || isLoading || (shouldRunAffectedCountQuery && affectedProductsCount === 0),
            endIcon: isLoading && react_1.default.createElement(generic_1.LoadingIndicator, null),
            onClick: handleSubmit,
        }, cancelButtonProps: {
            title: t({ key: 'CANCEL' }),
            onClick: () => {
                onClose();
            },
        }, title: t({ key: 'BULK_EDIT_ATTRIBUTES_DIALOG_TITLE' }) }, react_1.default.createElement(generic_1.ActionDialogContainer, null, react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledDialogContent, null, error && react_1.default.createElement(components_1.Alert, { severity: "error" }, error), react_1.default.createElement(product_attribute_control_container_1.ProductAttributeControl, { productTreeNodeId: selectedTreeNodeId, selectedAttributeId: selectedAttributeId, onChange: setSelectedAttributeId }), react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledGroup, null, react_1.default.createElement(ui_components_1.Typography, { className: 'title', strong: true, variant: "body2" }, t({ key: 'BULK_EDIT_EDIT_OPTIONS' })), react_1.default.createElement(ui_components_1.ToggleButtonGroup, { radioGroupMode: true, exclusive: true, options: toggleButtonOptions, value: operationType, minWidth: "8rem", disabled: !selectedAttributeId, onChange: (_e, value) => {
            if (value)
                setOperationType(value);
        } })), react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledGroup, null, react_1.default.createElement(ui_components_1.Typography, { className: 'title', strong: true, variant: "body2" }, t({ key: 'BULK_EDIT_CHOOSE_VALUES' })), react_1.default.createElement(product_value_control_container_1.ProductValueControl, { productTreeNodeId: selectedTreeNodeId, selectedAttributeId: selectedAttributeId, isDisabled: !selectedAttributeId, selectedValues: selectedValues, onChange: setSelectedValues, operationType: operationType }))), shouldRunAffectedCountQuery && (react_1.default.createElement(bulk_edit_product_attributes_dialog_styles_1.StyledInfoAlert, { severity: "info" }, isAffectedCountUiBusy ? (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(material_1.Skeleton, { height: 20, width: "65%" }), react_1.default.createElement(material_1.Skeleton, { height: 20, width: "75%" }))) : shouldShowAffectedProductsBanner && (react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({
        key: 'BULK_EDIT_AFFECTED_PRODUCTS_SUMMARY',
        values: {
            affectedCount: affectedProductsCount,
            totalCount: selectedProductsCount,
        },
    })), affectedProductsCount !== selectedProductsCount && (react_1.default.createElement(ui_components_1.Typography, { variant: "body2" }, t({
        key: 'BULK_EDIT_SKIPPED_PRODUCTS_SUMMARY',
        values: {
            skippedCount: skippedProductsCount,
        },
    }))))))))));
};
exports.BulkEditProductAttributesDialog = BulkEditProductAttributesDialog;
exports.default = exports.BulkEditProductAttributesDialog;
